import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import { TickIcon } from '../../assets/images';
import { topUpFailedLogo, topUpSuccessLogo } from '../../constants/appState';


class MessagePanel extends Component {
    render() {
        const { 
            title, 
            message, 
            isError, 
            isTopUp,
            children 
        } = this.props;

        return (
            <MessageWrapper className="message-panel">
                <div className={!!isTopUp ? 'page-icon topup' : 'page-icon'}>
                    {/* 
                    <div className="character">
                        <BunnyHeadIcon />
                    </div> 
                    */}
                    <div className="icon-holder">
                        { !!isError ? (
                            <div className={!!isTopUp ? 'topup-icon is-error' : 'icon is-error'}>
                                <span>!</span>
                            </div>
                        ) : (
                            <div className={!!isTopUp ? 'topup-icon' : 'icon'}>
                                {/* 
                                <PrestoAppTheme.images.TickIcon
                                    strokeColor={PrestoAppTheme.colors.baseGreen} 
                                    strokeWidth={7}
                                /> 
                                */}
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="page-message">
                    <h3 className="title">{title}</h3>
                    <div className="text" dangerouslySetInnerHTML={{__html: message}} />
                </div>
                
                {children}

            </MessageWrapper>
        );
    }
}

export default MessagePanel;


const MessageWrapper = styled.div`
    & .page-icon {
        position: relative;
        height: 100px;
        width: 80px;
        margin: ${PrestoAppTheme.layout.largeGap} auto;

        &.topup {
            height: 140px;
            width: 140px;
        }
        
        & .character {
            ${PrestoAppTheme.layout.absoluteFullStyle} 
        }

        & .icon-holder {
            display: flex;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;

            & .icon {
                height: 100%;
                width: 100%;
                background: url(${TickIcon}) center / contain no-repeat;

                &.is-error {
                    display: flex;
                    height: 80px;
                    font-size: 3.5rem;
                    font-weight: 400;
                    color: ${PrestoAppTheme.colors.prestoRed};
                    line-height: 1em;
                    border: 3px solid ${PrestoAppTheme.colors.prestoRed};
                    border-radius: 50%;
                    box-sizing: border-box;
                    background: transparent;
                    align-items: center;
                    justify-content: center;
                }
            }
            
            & .topup-icon {
                height: 100%;
                width: 100%;
                background: url(${topUpSuccessLogo}) center / contain no-repeat;

                &.is-error {
                    background: url(${topUpFailedLogo}) center / contain no-repeat;
                }
            }
        }
    }

    & .page-message {
        width: calc(100% - 2 * ${PrestoAppTheme.layout.largeGap});
        max-width: 300px;
        margin: ${PrestoAppTheme.layout.largeGap} auto;
        text-align: center;

        & h3.title {
            margin: 0 0 ${PrestoAppTheme.layout.smallGap};
            font-size: 1.1875rem; // 19px
            font-weight: 400;
        }

        & > .text {
            color: ${PrestoAppTheme.colors.baseGreyDark};
        }
    }
`;
